import $axios from '@/plugins/axios-instance'

export default {
    state: {

    },

    getters: {

    },

    actions: {
        getAccounts(context, data) {
            return  $axios.post(`/admin/GetAccounts`, data)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },

        getInformation(context, data) {
            return  $axios.post(`/admin/GetInformation`, data)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },

        getPayments(context, data) {
            return  $axios.post(`/admin/GetPayments`, data)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },
    }
}